import { type FieldError, type Control, type FieldPath, type FieldValues, useController } from 'react-hook-form';
import MultiSelect, { type MultiSelectProps } from '../MultiSelect';
import './ControlledMultiSelect.css';

export interface ControlledMultiSelectProps<TFieldValues extends FieldValues = FieldValues> extends Omit<MultiSelectProps, 'error' | 'value' | 'onChange'> {
    name: FieldPath<TFieldValues>;
    control: Control<TFieldValues>;
    error?: FieldError;
}

export default function ControlledMultiSelect<TFieldValues extends FieldValues = FieldValues>({
    name,
    control,
    error: errorProp,
    className = '',
    ...props
}: ControlledMultiSelectProps<TFieldValues>) {
    // Используем useController для работы с формой
    const { field, fieldState } = useController({
        control,
        name,
    });

    const error = fieldState.error || errorProp;

    const handleChange = (values: (string | number)[]) => {
        field.onChange(values);
    };

    const handleBlur = () => {
        field.onBlur();
    };

    return (
        <div className="controlled-multiselect-wrapper">
            <MultiSelect
                className={className}
                value={field.value || []}
                onChange={handleChange}
                onBlur={handleBlur}
                error={error ? error.message : undefined}
                {...props}
            />
        </div>
    );
}

